import React, { Component } from 'react';

class Email extends Component {
	render() {
		return (
			<section className="assessment name__age email">
				<div className="container-fluid">
					<h1 className="assessment__heading">Where can we email your detailed skin analysis?</h1>
					<span className="small__tital">(No spam, we feel you!)</span>
					<div className="name__age--field">
						<input className="form-control" type="email" placeholder="Email" name="" />
						<input className="btn btn-primary theme_btn" type="submit" value="SEE YOUR ROUTINE" />
					</div>
				</div>
			</section>
			);
	}
}


export default Email;